import { MouseEvent } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { theme, media } from '@vfit/shared/themes';

const commonRichTextStyles = css`
  b {
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.extrabold};
  }

  img {
    cursor: text;
    vertical-align: baseline;
  }

  a {
    color: ${theme.colors.text.primary};
    font-weight: ${theme.typography.fontWeight.bold};

    &:hover {
      color: ${theme.colors.text.link};
    }
  }

  button {
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.extrabold};
    font-size: ${theme.typography.fontSize.display5};
    
    color: ${theme.colors.text.brand};
    background: none;
    border: none;
    padding: 0;
    outline: inherit;

    span {
      font-family: ${theme.typography.fontFamily.secondary};
      font-weight: ${theme.typography.fontWeight.light};
      color: ${theme.colors.text.inverse}; 
      background-color: ${theme.colors.brand.primary};
      padding-left: ${theme.spacing.sm};
      padding-right: ${theme.spacing.sm};
      border-radius: 50%;
      cursor: pointer;
    }

    &:hover {
      span {
        background-color: ${theme.colors.text.linkHover};
      }
    }

    &:active {
      span {
        background-color: ${theme.colors.interactive.active};
      }
    }
  }
`;

export const TextConfig = styled.div<{ onClick: (e: MouseEvent<HTMLDivElement>) => void; dangerouslySetInnerHTML: { __html: string; }; }>`
  ${commonRichTextStyles}
  font-size: ${theme.typography.fontSize.display4};
  line-height: ${theme.typography.lineHeight.display4};
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.light};
  text-align: left;
  margin: 48px 23px 31px 23px;
  ${media.tablet`
    font-size: ${theme.typography.fontSize.display3};
    line-height: ${theme.typography.lineHeight.display3};
  `}
`;
export const TextDisclaimer = styled.div`
  ${commonRichTextStyles}
  font-size: ${theme.typography.fontSize.body2};
  line-height: ${theme.typography.lineHeight.body2};
  font-family: ${theme.typography.fontFamily.secondary};
  font-weight: ${theme.typography.fontWeight.bold};
  text-align: left;
  margin: 48px 23px 31px 23px;
`;
export const ModalTitleText = styled.div`
  ${commonRichTextStyles}
  font-size: ${theme.typography.fontSize.display4};
  line-height: ${theme.typography.lineHeight.display4};
  font-weight: ${theme.typography.fontWeight.extrabold};
  text-align: left;
  margin: 48px 23px 31px 23px;
`;
export const ModalContentText = styled.div`
  ${commonRichTextStyles}
  font-size: ${theme.typography.fontSize.body1};
  line-height: ${theme.typography.lineHeight.body1};
  font-weight: ${theme.typography.fontWeight.light};
  text-align: left;
`;

export const DisclaimerContainer = styled.div`
  font-family: ${theme.typography.fontFamily.secondary};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.text.secondary};
  img {
    width: 18px;
  }
`;

export const ModalTitle = styled.div`
  div {
    margin: 0;
    margin-bottom: ${theme.spacing.lg};
  }
`;

export const ButtonContainer = styled.div`
  margin: 0 auto;
  text-align: center;
  margin-bottom: 80px;
  button {
    margin: 0 auto;
    width: auto;
    max-width: 400px;
    span {
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      display: block;
    }
  }
  white-space: nowrap;
`;

export const ModalContent = styled.div`
  div {
    margin: 0;
  }
`;
